import { useEffect } from "react";
import axios from "axios";
import "./AIs.css";
import { Link, useNavigate } from "react-router-dom";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import PageHeading from "../../../Components/PageHeading/PageHeading";
import img1 from "../../../Assets/Images/whalesai-new/text-ai.png";
import img2 from "../../../Assets/Images/whalesai-new/image-ai.png";
// import img3 from "../../../Assets/Images/whalesai-new/post-ai.png";
// import img4 from "../../../Assets/Images/whalesai-new/text-video-ai.png";
import img5 from "../../../Assets/Images/whalesai-new/comic.png";
import img6 from "../../../Assets/Images/news-video-ai.png";
import img7 from "../../../Assets/Images/whalesai-new/voice_ai.png";
import img8 from "../../../Assets/Images/whalesai-new/toy_ai.png";
import img9 from "../../../Assets/Images/developer-ai.png";
import img10 from "../../../Assets/Images/whalesai-new/photo-post-ai.png";
import img11 from "../../../Assets/Images/consultant-ai.png";
import img12 from "../../../Assets/Images/whalesai-new/photo-poster-ai.png";
import img13 from "../../../Assets/Images/whalesai-new/business-plan-ai.png";
import img14 from "../../../Assets/Images/whalesai-new/product-video-ai.png";
import img15 from "../../../Assets/Images/whalesai-new/facts-of-the-day-ai.png";
import img16 from "../../../Assets/Images/whalesai-new/marketing-poster-ai.png";
import { FiArrowRight } from "react-icons/fi";

const useLocation = () => {
  const location = window.location.pathname;
  return location;
};

const AIs = () => {
  const location = useLocation();
  useEffect(() => {
    const countVisitor = async () => {
      axios.get("https://backend.whalesai.com/api/v1/visitor")
    };

    // const location = useLocation();

    const setFp = async () => {
      const fp = await FingerprintJS.load();
      const { visitorId } = await fp.get();
      await axios.post(
        "https://backend.whalesai.com/api/v1/visitor",
        {
          visitorId,
        }
      );
      await countVisitor();
    };

    setFp();
  }, []);
  const navigate = useNavigate();

  const ais = [
    {
      redirect: "/business-plan-ai",
      nth: "one",
      img: img13,
      header: "BUSINESS PLAN AI",
      credit: '415 Credits per plan',
    },
    {
      redirect: "/comic-video-ai",
      nth: "two",
      img: img5,
      header: "COMIC VIDEO AI",
      credit: '250 Credits per video',
    },
    // {
    //   redirect: "/consultant-ai",
    //   nth: "three",
    //   img: img11,
    //   header: "SOCIAL MEDIA CONSULTANT",
    //   credit: '1 Credit per 3000 characters',
    // },
    {
      redirect: "/facts-of-the-day-ai",
      nth: "four",
      img: img15,
      header: "FACTS OF THE DAY AI",
      credit: '75 Credits per image',
    },
    // {
    //   redirect: "/developer-ai",
    //   nth: "three",
    //   img: img9,
    //   header: "DEVELOPER AI",
    //   credit: '834 Credits per project',
    // },
    {
      redirect: "/image-ai",
      nth: "five",
      img: img2,
      header: "IMAGE AI",
      credit: '10 Credits per image',
    },
    {
      redirect: "/promo-campaign-ai",
      nth: "six",
      img: img16,
      header: "PROMO CAMPAIGN AI",
      credit: '75 Credits per image',
    },
    // {
    //   redirect: "/news-video-ai",
    //   nth: "five",
    //   img: img6,
    //   header: "NEWS VIDEO AI",
    //   credit: '35 Credits per video',
    // },
    {
      redirect: "/social-post-ai",
      nth: "seven",
      img: img10,
      header: "SOCIAL POST AI",
      credit: '75 Credits per carousel',
    },
    {
      redirect: "/poster-design-ai",
      nth: "eight",
      img: img12,
      header: "POSTER DESIGN AI",
      credit: '75 Credits per poster',
    },
    {
      redirect: "/product-video-ai",
      nth: "nine",
      img: img14,
      header: "PRODUCT VIDEO AI",
      credit: '75 Credits per second',
    },
    // {
    //   redirect: "/post-ai",
    //   nth: "seven",
    //   img: img3,
    //   header: "POST AI",
    //   credit: '10 Credits per post',
    // },
    {
      redirect: "/text-ai",
      nth: "ten",
      img: img1,
      header: "TEXT AI",
      credit: '1 Credit per 3000 characters',
    },
    // {
    //   redirect: "/text-video-ai",
    //   nth: "nine",
    //   img: img4,
    //   header: "TEXT VIDEO AI",
    //   credit: '35 Credits per video',
    // },
    {
      redirect: "/toy-stories-ai",
      nth: "eleven",
      img: img8,
      header: "TOY STORIES AI",
      credit: '10 Credits per story',
    },
    {
      redirect: "/voice-ai",
      nth: "twelve",
      img: img7,
      header: "VOICE AI",
      credit: '1 Credit per 3000 characters',
    },
  ];

  const storedNumber = localStorage.getItem("randomNumber");

  useEffect(() => {
    const generateRandomNumber = () => {
      const otp = Math.floor(Math.random() * 101) + 100;
      localStorage.setItem("randomNumber", otp.toString());
    };

    if (!storedNumber) {
      generateRandomNumber();
    }

    const intervalId = setInterval(generateRandomNumber, 10 * 60 * 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [storedNumber]);

  return (
    <div>
      <PageHeading title="DO IT" />
      <section className="diy-section">
        {location !== "/" && (
          <div className="diy-consultant-banner">
            <Link
              to="/social-media-consultant"
              className="consultant-button"
            >
              🤖 Your <strong>Social Media Consultant</strong> is ready to help you plan your social media marketing. Click here to discuss your strategy.
            </Link>
          </div>
        )}

        <div className="diy-tools-grid">
          {ais.map((eachAi, index) => (
            <div
              key={index}
              onClick={() => navigate(eachAi?.redirect)}
              className="diy-tool-card"
            >
              <div className="diy-tool-card-image">
                <img src={eachAi.img} alt={eachAi.header} />
              </div>
              <div className="diy-tool-card-body">
                <h5 className="diy-tool-card-title">{eachAi.header}</h5>
                <div className="diy-tool-card-footer">
                  <span className="diy-tool-card-credit">
                    <span className="diy-tool-card-credit-icon">💎</span>
                    {eachAi.credit}
                  </span>
                  <span className="diy-tool-card-arrow">
                    <FiArrowRight size={16} />
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default AIs;
